module.exports = __webpack_public_path__ + "img/arrow-right.55e0e89b.svg";